import React from 'react';
import {
  Box,
  Typography,
} from '@material-ui/core';

import FormikConfigForm from 'src/components/formik/FormikConfigForm';
import FormikCheckbox from 'src/components/formik/FormikCheckbox';
import { Field, Widget, WidgetPayload } from 'src/types';
import { FIELD_DETAILS_BY_FIELD_TYPE } from 'src/views/constants/fieldConstants';
import { InspectorProps, WIDGET_DETAILS_BY_WIDGET_TYPE } from 'src/views/constants/widgetConstants';

function BasicFieldWidgetInspector({
  saveWidget,
  deleteWidget,
  selectedWidgetField,
  selectedWidget
}: InspectorProps) {
  if (!selectedWidgetField) return null;

  const fieldsConfig = [
    {
      name: 'isRequired',
      component: () => (
        <FormikCheckbox
          label="Field is required"
          name="isRequired"
          fullWidth
        />
      ),
    },
    {
      name: 'defaultValue',
      component: () => WIDGET_DETAILS_BY_WIDGET_TYPE[selectedWidget.type].renderer({
        name: 'defaultValue',
        label: 'Default value',
        options: selectedWidgetField.options
      }),
    },
  ];

  return (
    <>
      <Box pb={2}>
        <Typography variant="h5">
          {FIELD_DETAILS_BY_FIELD_TYPE[selectedWidgetField.type].label}: {selectedWidgetField.name}
        </Typography>
      </Box>
      <FormikConfigForm
        result={selectedWidget.data}
        fieldsConfig={fieldsConfig}
        onSubmit={(widgetData: any, afterSubmitCallback: any) => {
          saveWidget(selectedWidget.id, {
            data: {
              ...selectedWidget.data,
              ...widgetData,
            }
          }).finally(() => {
            afterSubmitCallback();
          });
        }}
        tertiaryButton={{
          label: 'Delete',
          onClick: () => deleteWidget(selectedWidget.id),
          look: 'error'
        }}
        autoSave
      />
    </>
  );
}

export default BasicFieldWidgetInspector;
